/**
 * 오프라인 배너 (FN-085 전역 오류·오프라인 정책, 2026-08-28).
 *
 * 연결이 끊기면 앱바 바로 아래에 '오프라인이에요' 를 띄우고, 돌아오면 걷는다.
 *   · 캐시로 숫자를 지어내지 않는다 — 배너는 "지금 보이는 값이 새 값이 아닐 수 있다" 는 신호다
 *   · 조회 영역별 재시도 버튼은 각 화면의 몫(개발) — 여기는 상태만 말한다
 *   · 스캔 인식은 단말에서 되므로 막지 않는다 (FN-023)
 *
 * ⚠ 화면을 **덮지 않는다.** 종전 OfflineScreen 은 풀스크린 오버레이라 오프라인이면
 *   스캔까지 막혔는데, 인식은 단말에서 돌아 네트워크가 없어도 된다. 막을 것은
 *   시세 조회뿐이고 그건 각 화면의 인라인 재시도가 받는다.
 * ⚠ 상태는 navigator.onLine 이 아니라 useNetworkStatus 를 쓴다 — 네이티브에서는
 *   Capacitor Network 가 실제 연결을 보고, 웹에서는 navigator.onLine 으로 물러선다.
 *   어느 쪽이든 "붙어 있는데 인터넷이 안 되는" 경우는 못 잡는다. 그건 요청 실패가 받는다.
 */
import { useTranslation } from "react-i18next";
import { useNetworkStatus } from "../../native/network";
import Notice from "./Notice";
import styles from "./OfflineNotice.module.css";

export default function OfflineNotice() {
  const { t } = useTranslation("common");
  const { connected } = useNetworkStatus();

  if (connected) return null;
  return (
    <div className={styles.slot} role="status" aria-live="polite">
      <Notice status="warning" title={t("state.offline")} description={t("state.offlineBody")} />
    </div>
  );
}
